define('shared/remote/order/current',[
    'shared/lib/RSVP', 
    'shared/page/apiVersion',
    'shared/remote/ajax',
    'shared/remote/account/current'
], 
function (
    RSVP, 
    getAPIVersion, 
    ajax,
    getCurrentAccount
) {
    var URL_NEW_HOUSE_SEARCH = '/1/api/commerce-gateway/order/search?dataLayer=item';

    return function(){
        var xEFAccessJWT;
        return getCurrentAccount({raw: true})
            .then(function(jwt){
                xEFAccessJWT = jwt.access;
                return getAPIVersion();  
            })
            .then(function(apiVersion){
                if (apiVersion === 'new-house') {
                    return ajax({
                        url: URL_NEW_HOUSE_SEARCH,
                        type: 'GET',
                        dataType: 'json',
                        headers: {
                            'X-EF-ACCESS': xEFAccessJWT
                        }
                    });
                } else {
                    return RSVP.reject('Parameter is not enough.');
                }
            });
    };
});
